import React from 'react';
import Parse from 'parse';
import {Label} from 'react-bootstrap'

export default class RoleCell extends React.Component {

    roles = ["--", "TM", "APL", "PL"];
    styles = {"PL":"success", "APL":"primary", "TM": "info"};

    constructor(props) {
        super(props);
        this.state = {
            user: props.user,
            project: props.project,
            role: "--",
            style: "",
            editing: false,
        };
        this.edit = this.edit.bind(this);
        this.update = this.update.bind(this);
    }

    componentDidMount() {

        let _this = this;

        let Project = Parse.Object.extend("Project");
        let project = new Project();
        project.id = this.state.project.id;

        let User = Parse.Object.extend("User");
        let user = new User();
        user.id = this.state.user.id;

        let Membership = Parse.Object.extend("Membership");
        let roleQuery = new Parse.Query(Membership);
        roleQuery.equalTo("user", user);
        roleQuery.equalTo("project", project);
        roleQuery.first().then(membership => {
            _this.setRole(membership.get("role"));
        });

    }

    setRole(newRole) {
        this.setState({
            role: newRole,
            style: this.styles[newRole]
        });
    }

    edit() {
        this.setState({editing: true});
    }

    update(event) {

        let role = event.target.value;
        console.log(role);

        this.setState({editing: false});
        
        let _this = this;

        let Project = Parse.Object.extend("Project");
        let project = new Project();
        project.id = this.state.project.id;

        let User = Parse.Object.extend("User");
        let user = new User();
        user.id = this.state.user.id;

        let Membership = Parse.Object.extend("Membership");

        if(this.state.role === "--") {

            let membership = new Membership();
            membership.set("user", user);
            membership.set("project", project);
            membership.set("role", role);
            membership.save().then(() => {
                _this.setState({role: role, style: _this.styles[role]})
            })

        } else {

            let roleQuery = new Parse.Query(Membership);
            roleQuery.equalTo("user", user);
            roleQuery.equalTo("project", project);
            roleQuery.first().then(membership => {
                if(role === "--"){
                    membership.destroy().then(() => {
                        _this.setState({role: role, style: _this.styles[role]})
                    })
                } else {
                    membership.set("role", role);
                    membership.save().then(() => {
                        _this.setState({role: role, style: _this.styles[role]})
                    })
                }
            });

        }

        
    }

    render() {
        return (
            <td onClick={this.edit} className="role">
                {this.state.editing ? (
                    <select value={this.state.role} onChange={this.update}>
                        {this.roles.map(role => {
                            return (
                                <option key={role}>{role}</option>
                            )
                        })}
                    </select>
                ) : (
                (this.state.role !== "--") ? (
                    <Label bsStyle={this.state.style}>{this.state.role}</Label>
                    ) :
                    (this.state.role)
                )}
            </td>
        );
    }

}


// WEBPACK FOOTER //
// ./src/roleCell.js